import { Injectable } from '@angular/core';
import { AppConfig } from './app-config.model';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
//@Injectable()
@Injectable({providedIn: 'root'})
export class AppConfigService {
    private appConfig: AppConfig = new AppConfig();


    getUrlAAD(){
        return this.appConfig.urlAAD;
    }

    getUrlApi() {
        return this.appConfig.url;
    }

    getHeadersJson() {
        return {
            headers: new HttpHeaders()
                        .set('Content-Type', 'application/json' )
                        .set('Authorization', 'Bearer ' + localStorage.getItem('tk'))
        };
    }
    getUser() {
        if (localStorage.getItem('usr') !== null) {
            const currentUser = this.getInfoEncrypt(localStorage.getItem('usr'));
            return currentUser;
        }
        // return 'typeUser';
    }
    setHeadersGETParams(params) {      
        const accessToken = localStorage.getItem('tk');
        const reqData = {
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        };
        if(params) {
            let reqParams = {};        
            Object.keys(params).map(k =>{
                reqParams[k] = params[k];
            });
            reqData['params'] = reqParams;
        }
        return reqData;
    }

    getHeadersBlob() {
        return {
            headers: new HttpHeaders()
            .set('Content-Type', 'application/json' )
            .set('Authorization', 'Bearer ' + localStorage.getItem('tk')),
            // Ignore this part or  if you want full response you have 
            // to explicitly give as 'boby'as http client by default give res.json()
            observe:'response' as 'body',
           // have to explicitly give as 'blob' or 'json'
            responseType: 'blob' as 'blob'  
        };
    }

    getHeadersMultipart() {
        return {
            headers: new HttpHeaders({                       
                            'Authorization': 'Bearer ' + localStorage.getItem('tk'),
                        })
        };
    }
    getHeadersMultipartblob() {
        return {
            headers: new HttpHeaders({                       
                            'Authorization': 'Bearer ' + localStorage.getItem('tk'),
                        })
        };
    }
    getInfoEncrypt(data) {
        //const decr = CryptoJS.AES.decrypt(data,'aS35LwFU?}{0').toString(CryptoJS.enc.Utf8);
        //return JSON.parse(decr);
        return JSON.parse(data)
    }
    getDepaNameEmployee() {
        if (localStorage.getItem('em') !== null) {
            const employee = this.getInfoEncrypt(localStorage.getItem('em'));
            return employee.depa;
        }
        return '';
    }
    getNameTypeUser() {
        if (localStorage.getItem('usr') !== null) {
            const currentUser = this.getInfoEncrypt(localStorage.getItem('usr'));
            const depaUser = this.getDepaNameEmployee();
            if (currentUser.tipo === 'ciudadano' || currentUser.tipo === 'autoridad') {
                return currentUser.tipo;
            } else {
                return this.getTypeEmployee();
            }
        }
        // return 'typeUser';
    }
    getTokenString() {
        return 'Bearer ' + localStorage.getItem('tk');
    }
    getMunicipio() {
        return this.appConfig.municipio;
    }
    getEntidad() {
        return this.appConfig.ENTIDAD;
    }
    getClave_Entidad() {
        return this.appConfig.CLAVE_ENTIDAD;
    }
    getCurrentUser(){
        if(localStorage.getItem('usr') !== null) {
            return JSON.parse(localStorage.getItem('usr'));
        }
    }

    getTypeEmployee(){
        if(localStorage.getItem('tyem') !== null) {
            return localStorage.getItem('tyem');
        }
    }

    getDepaEmployee(){
        if(localStorage.getItem('em') !== null) {
            const employee =  JSON.parse(localStorage.getItem('em'));
            return employee.nume;
        }
    }

    getDateFormat(date){
        moment.locale('es-Mx');
        return moment(date).format('DD-MM-YYYY h:mm:ss') //'MMMM Do YYYY, h:mm:ss a'
    }

    capitalize_Words(str){
        return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    }

    _getMsjError(error){
        error = error.error.error;

        if(typeof error === 'object'){
            for (const field in error) {
                if (Object.prototype.hasOwnProperty.call(error, field)) {
                    console.log(field, error[field])
                    return error[field]; 
                }
            }
        }
        
        return error
    }

    formatUneExpediente(identification) {
        let char_split = '';
        if(identification.includes('-')) {
            char_split = '-'
        }else if(identification.includes('/')) {
            char_split = '/'
        }else {
            return 'false'
        }

        const elements = identification.split(char_split);
        
        return elements[0].trim() + char_split + elements[1].trim(); 
    }
}
